export const DEFAULT_RANGE = { startHour: 6, endHour: 18 } as const;

export interface TimeAxis {
  startMin: number;
  endMin: number;
  total: number;
  hours: number[];
}

export function buildAxis(startHour: number, endHour: number): TimeAxis {
  const startMin = startHour * 60;
  const endMin = endHour * 60;
  const total = endMin - startMin;
  const hours: number[] = [];
  for (let h = startHour; h <= endHour; h++) hours.push(h);
  return { startMin, endMin, total, hours };
}

export function timeToMin(hhmm: string): number {
  const [h, m] = hhmm.split(':').map(Number);
  return (h || 0) * 60 + (m || 0);
}

export function pctOf(minutes: number, startMin: number, total: number): number {
  if (total <= 0) return 0;
  return ((minutes - startMin) / total) * 100;
}
